<template>
  <div v-if="isLoading" class="el-loading-mask is-fullscreen" style="z-index: 2006;">
    <div class="el-loading-spinner">
      <svg viewBox="25 25 50 50" class="circular">
        <circle cx="50"
                cy="50"
                r="20"
                fill="none"
                class="path"/></svg>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import debounce from 'lodash.debounce';

export default {
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters(['ajaxCount']),
  },
  watch: {
    ajaxCount(val) {
      if (val > 0) {
        this.isLoading = true;
      } else {
        this.doDebounce();
      }
    },
  },
  methods: {
    // eslint-disable-next-line func-names
    doDebounce: debounce(function () {
      this.isLoading = false;
    }, 100),
  },
};
</script>
